export default __webpack_public_path__ + "static/media/inactive-arrow.281d4bef.svg";